import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const BounceAnimation = keyframes`
  0% { margin-bottom: 0; }
  50% { margin-bottom: 15px }
  100% { margin-bottom: 0 }
`;
const DotWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

interface DotProps {
  color?: string;
  delay: string;
}

const Dot = styled.div<DotProps>`
  background-color: ${({ color }) => color || 'black'};
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  /* Animation */
  animation: ${BounceAnimation} 0.5s linear infinite;
  animation-delay: ${({ delay }) => delay};
`;

const LoadingDots: React.ComponentType<{
  color?: string;
}> = ({ color }) => (
  <DotWrapper>
    <Dot color={color} delay="0s" />
    <Dot color={color} delay=".1s" />
    <Dot color={color} delay=".2s" />
  </DotWrapper>
);

export default LoadingDots;
